import React from "react";
import Button from "../../components/Button/Button";
import { sortByOrderAscending } from "../../helper/helper";
import { useDispatch } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";
const HoppersCafeHeroPage = ({ components, heroBackground }) => {
    const dispatch = useDispatch()
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersCafeHeroPage-subheader":
                return <div className="HoppersCafeHeroPage-content-hdrline">
                    <div className="HoppersCafeHeroPage-content-hdrline-line" />
                    {component?.Props?.text}
                </div>
            case "HoppersCafeHeroPage-header":
                return <div className="HoppersCafeHeroPage-content-header">
                    {component?.Props?.header1}<br />
                    {component?.Props?.header2}
                </div>
            case "HoppersCafeHeroPage-content":
                return <div className="HoppersCafeHeroPage-content-des">
                    {component?.Props?.text}
                </div>
            case "HoppersCafeHeroPage-btnContainer":
                return <div className="HoppersCafeHeroPage-content-btn-cont">
                    {component?.Components.map((btn, key) => {
                        return (
                            <Button
                                text={btn?.Props?.btnText}
                                width={window.screen.width < 900 ? "190px" : btn?.Props?.width}
                                isArrow={btn?.Props?.isArrow}
                                isSecondary={btn?.Props?.isSecondary}
                                key={key}
                                onClick={() => {
                                    if (btn?.Props?.href && btn?.Props?.href?.includes("https://")) {
                                        window.open(btn?.Props?.href, '_blank')
                                    } else {
                                        dispatch(setIsComing(true))
                                    }
                                }} />
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="HoppersCafeHeroPage"
            style={{
                backgroundImage: `linear-gradient(125.42deg, rgba(26, 26, 26, 0.8) 0%, rgba(26, 26, 26, 0.4) 100%),
                url(${heroBackground})`
            }}>
            <div className="HoppersCafeHeroPage-content">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getComponents(component))
                })}
            </div>
        </div>
    )

}
export default HoppersCafeHeroPage